import { OrganizationQuery } from '@core/organization/organization.query';
import { Client } from '@core/models/client.model';

import {
  ProcessQueueOrgNameContext,
  ProcessQueueOrgNameLoggedInUser,
  readActiveThemePartnerFromStorage,
} from './process-queue-org-name.util';

export function buildProcessQueueOrgNamePartnerContext(params: {
  partnerUid?: string | null;
  loggedInUser?: ProcessQueueOrgNameLoggedInUser | null;
  organizationQuery?: OrganizationQuery | null;
}): Pick<ProcessQueueOrgNameContext, 'partnerUid' | 'activeThemePartner' | 'organizationPartners'> {
  const activeOrganization = params.organizationQuery?.getActive?.() as
    | { partners?: Array<{ uid?: string; fullCompanyName?: string }> }
    | undefined;

  return {
    partnerUid: params.partnerUid ?? null,
    activeThemePartner: readActiveThemePartnerFromStorage(),
    organizationPartners: activeOrganization?.partners ?? null,
  };
}

export function buildIssuerOrganizationName(
  organizationQuery?: OrganizationQuery | null,
): string | null {
  const activeOrganization = organizationQuery?.getActive?.() as { fullCompanyName?: string } | undefined;
  const issuerName = String(activeOrganization?.fullCompanyName ?? '').trim();
  return issuerName || null;
}

export function buildProcessQueueOrgNameBaseContext(params: {
  emittentCompanyName: unknown;
  currentUserType: unknown;
  activeClientId?: string | null;
  storedClientId?: string | null;
  currentRoute?: string | null;
  historyReturnUrl?: string | null;
  storedReturnUrl?: string | null;
  activeClient?: Client | null;
  clientQuery?: ProcessQueueOrgNameContext['clientQuery'];
  loggedInUser?: ProcessQueueOrgNameLoggedInUser | null;
  partnerUid?: string | null;
  organizationQuery?: OrganizationQuery | null;
}): ProcessQueueOrgNameContext {
  return {
    emittentCompanyName: params.emittentCompanyName,
    issuerOrganizationName: buildIssuerOrganizationName(params.organizationQuery),
    currentUserType: params.currentUserType,
    activeClientId: params.activeClientId ?? null,
    storedClientId: params.storedClientId ?? null,
    currentRoute: params.currentRoute ?? null,
    historyReturnUrl: params.historyReturnUrl ?? null,
    storedReturnUrl: params.storedReturnUrl ?? null,
    activeClient: params.activeClient ?? null,
    clientQuery: params.clientQuery ?? null,
    loggedInUser: params.loggedInUser ?? null,
    ...buildProcessQueueOrgNamePartnerContext({
      partnerUid: params.partnerUid,
      loggedInUser: params.loggedInUser,
      organizationQuery: params.organizationQuery,
    }),
  };
}
